import React, { useEffect, useState } from "react";
import { post } from "../../helpers/api_helper";
//redux
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import Loader from "common/loader";
import { Trans } from "react-i18next";
import Breadcrumb from "components/Common/Breadcrumb";
import { ADD_TEXT } from "helpers/api_endpoints";

const AddPolicy = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [refId, setrefId] = useState(1);//terms ref
    const [status, setStatus] = useState(1);
    const [name, setTitle] = useState('');
    const [value, setDescription] = useState('');

    useEffect(() => {
        setLoading(false);
    }, []);

    const handleSubmit = () => {
        post(ADD_TEXT, { name, value, refId:"3", status })
            .then(response => {
                if (response.code == 201) {
                    navigate('/privacy-policy', { state: { successMsg: 'Added SuccessFully' } });
                }
            })
            .catch(error => {

            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumb title="Terms & Conditions" breadcrumbItem="Add Terms & Conditions" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-12 mt-2">
                                                    <Label className="form-label"><Trans>Title</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter User Name"
                                                        type="text"
                                                        onChange={(e) => setTitle(e.target.value)}
                                                        required={language.id==1||language.id==2?true:false} ></Input>
                                                </div>

                                                <div className="form-group col-md-12 mt-2">
                                                    <Label className="form-label"><Trans>Description</Trans></Label>
                                                    <textarea
                                                        name="description"
                                                        value={value}
                                                        rows={5}
                                                        className="form-control"
                                                        placeholder="Enter Email"
                                                        type="text"
                                                        onChange={(e) => setDescription(e.target.value)}
                                                        required={language.id==1||language.id==2?true:false} ></textarea>
                                                </div>


                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddPolicy;